<template>
  <v-card class="elevation-0">
    <v-row class="pa-0 ma-0">
      <v-col cols="6">
        <v-card class="mx-auto">
          <!-- <v-card-title> Register Your P-Spot </v-card-title> -->

          <!-- <v-img
            class="align-end text-white"
            height="200"
            src="/scheme-serial-numer.jpeg"
            contain
          /> -->

          <!-- <v-card-subtitle class="pt-4"> Number 10 </v-card-subtitle> -->

          <v-card-text>
            <HelpFormInput
              v-model="cpm"
              label="Floor CPM"
              placeholder="Enter Floor CPM"
              help-text="Floor CPM is the minimum cost per thousand impressions. for the ad placement."
              persistent-counter
              :icon="'mdi-currency-usd'"
              :rules="rules.cpm"
              :hint="'Floor CPM must be a number between $0.01 and $50.00'"
              @update:model-value="
                (v) =>
                  onUpdate({
                    ...modelValue,
                    cpm: v,
                  })
              "
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="mx-auto">
          <!-- <v-card-title> Device Specs </v-card-title> -->
          <v-img
            class="align-end text-white"
            height="200"
            src="/screen-specs.webp"
            contain
          />
          <v-card-text>
            <v-row>
              <v-col cols="6"> </v-col>
              <v-col cols="6"> </v-col>
            </v-row>
            <v-row>
              <v-col cols="6"> </v-col>
              <v-col cols="6"> </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>
  
  
  <script>
import { FormatterHelper } from "@/helpers/formatter.helper";
import HelpFormInput from "../../atoms/common/inputs/HelpFormInput.vue";

export default {
  components: {
    HelpFormInput,
  },
  props: {
    modelValue: {
      type: Object,
      default: () => ({
        cpm: 0,
      }),
    },
  },
  emits: ["next", "update:modelValue"],
  data() {
    return {
      cpm: 0,

      rules: {
        cpm: [
          (v) => !!v || "Floor CPM is required",
          (v) => Number(v) > 0 || "Floor CPM must be greater than 0",
          (v) => /^[0-9]+$/.test(v) || "Floor CPM must be a number",
          (v) => (v && Number(v) <= 50) || "Floor CPM must be less than $50",
          (v) =>
            (v && Number(v) >= 0.01) || "Floor CPM must be greater than $0.01",
        ],
      },
    };
  },
  computed: {},

  created() {},
  methods: {
    onUpdate(value) {
      console.log("value", value);

      this.$emit("update:modelValue", value);
    },
    formatPrice(value) {
      return FormatterHelper.price(value);
    },
  },
};
</script>